// extracted by mini-css-extract-plugin
module.exports = {"row":"ProductTable__row___i9IPz","row--odd":"ProductTable__row--odd___h-bqs","cell":"ProductTable__cell___-xH-x","header":"ProductTable__header___2BKKb"};